/**
 * SECHI-RICERCA (24/09/2026, rivisto 25/09/2026) — la ricerca del negozio con il metodo di Onautica
 * (faq-tool\deploy-search-enhancer.js, «search-synonym-expander.js» sul tema di Onautica).
 * Dati: metafield del negozio custom.ricerca_dizionario (JSON), scritto da tool\ricerca-deploy.js,
 * stampato nel <head> della pagina di ricerca dallo snippet sechi-ricerca (script NON differito: gira prima che
 * la pagina si disegni, così i salti non si vedono).
 *  1. REDIRECT: parole che portano sempre a un'altra ricerca (esatte, o contenute se «partial»). Subito, nel <head>.
 *  2. SINGOLARE = PLURALE: ogni forma va sulla forma canonica (quella che compare in più titoli) → «tasselli» e
 *     «tassello» danno gli stessi risultati. A video resta la parola scritta dal cliente (_q). Subito, nel <head>.
 *  3. SINONIMI: si va sulla parola di arrivo del gruppo («frullino» → «smerigliatrice»)
 *     a) se la ricerca dà 0 risultati (anche per un pezzo della frase), oppure
 *     b) (dal 25/09) se la parola cercata è ESATTAMENTE un termine del dizionario e nessuno dei primi 5 risultati la
 *        contiene, né contiene un altro termine del suo gruppo: la ricerca di Shopify trova sempre qualcosa
 *        («frullino» → chiave a rullino), quindi «0 risultati» da solo non bastava.
 *     Una ricerca che trova già prodotti pertinenti non si tocca mai (lezione di Onautica).
 *     Mentre si controlla (solo per le parole del dizionario) i risultati restano nascosti: niente sfarfallio.
 * Niente cicli: dopo un salto l'indirizzo porta _pc / _syn / _red e non si salta più. location.replace = il tasto
 * indietro torna alla pagina di prima, non alla ricerca intermedia.
 * Annullare: togliere la riga {% render 'sechi-ricerca' %} da layout/theme.liquid (ricerca-deploy.js --togli).
 */
(function () {
  'use strict';
  if (window.location.pathname !== '/search') return;
  var el = document.getElementById('sechi-ricerca-dati');
  if (!el) return;
  var dati;
  try { dati = JSON.parse(el.textContent); if (typeof dati === 'string') dati = JSON.parse(dati); } catch (e) { return; }
  var SIN = dati.synonyms || {}, RED = dati.redirects || [], PLU = dati.plural || {};
  var par = new URLSearchParams(window.location.search);
  var q = par.get('q');
  if (!q || q.trim().length < 2) return;
  var scritta = par.get('_q') || q;

  // ---------- testo ----------
  var STOP = {}; 'di da per con il lo la le gli i un una uno in a e del della dello dei degli delle al alla allo ai agli alle su sul sulla x mm cm m kg lt l pz pezzi set'.split(' ').forEach(function (w) { STOP[w] = 1; });
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function parole(s) { return norm(s).split(/[^a-z0-9]+/).filter(function (w) { return w && !STOP[w]; }); }
  function radice(w) { return (/\d/.test(w) || w.length < 4) ? w : w.replace(/h?[aeiou]+$/, ''); }
  function copre(query, titolo) {
    var qs = parole(query).map(radice).filter(function (w, i, a) { return w.length >= 2 && a.indexOf(w) === i; });
    if (!qs.length) return false;
    var t = parole(titolo).map(radice);
    var ok = qs.filter(function (w) { return t.some(function (x) { return x === w || (w.length >= 5 && x.indexOf(w) === 0) || (x.length >= 5 && w.indexOf(x) === 0); }); }).length;
    return ok / qs.length >= (parole(query).length <= 2 ? 1 : 0.66);
  }

  // ---------- dizionario ----------
  function vaiA(nuova, extra) {
    var p = new URLSearchParams(window.location.search);
    ['q', 'page', '_q', '_pc', '_syn', '_red'].forEach(function (k) { p.delete(k); });
    p.set('q', nuova);
    Object.keys(extra || {}).forEach(function (k) { p.set(k, extra[k]); });
    partito = true;
    window.location.replace('/search?' + p.toString());
  }
  function redirect(x) {
    x = x.trim().toLowerCase();
    for (var i = 0; i < RED.length; i++) if (!RED[i].match && x === RED[i].cerca) return RED[i].url;
    // solo in avanti: la query deve CONTENERE il termine (il contrario rompeva «parabordi» su Onautica)
    for (var j = 0; j < RED.length; j++) if (RED[j].match === 'partial' && x.indexOf(RED[j].cerca) !== -1) return RED[j].url;
    return null;
  }
  function canonica(x) {
    if (/[*(":]/.test(x) || / (OR|AND|NOT) /.test(x)) return x;
    var ws = x.trim().split(/\s+/);
    if (ws.length > 5) return x;
    var cambiata = false;
    var out = ws.map(function (w) { var c = PLU[w.toLowerCase()]; if (c && c !== w.toLowerCase()) { cambiata = true; return c; } return w; });
    return cambiata ? out.join(' ') : x;
  }
  function sinonimo(x) {  // anche un pezzo della frase: solo per il caso 0 risultati
    x = x.trim().toLowerCase();
    if (SIN[x]) return SIN[x][0];
    var w = x.split(/\s+/).filter(Boolean);
    for (var n = Math.min(3, w.length); n >= 1; n--) {
      for (var i = 0; i + n <= w.length; i++) {
        var g = w.slice(i, i + n).join(' ');
        if (n === 1 && g.length < 3) continue;
        if (SIN[g]) return SIN[g][0];
      }
    }
    return null;
  }
  function sinonimoEsatto(x) { x = x.trim().toLowerCase().replace(/\s+/g, ' '); return SIN[x] ? SIN[x][0] : null; }
  function gruppo(arrivo) { var t = [arrivo]; for (var k in SIN) if (SIN[k][0] === arrivo && k !== arrivo) t.push(k); return t; }

  // ---------- 1-2: subito, prima che la pagina si disegni ----------
  var partito = false;
  var saltato = par.get('_syn') || par.get('_pc') || par.get('_red');
  if (!saltato) {
    var r = redirect(scritta);
    if (r) {
      partito = true;
      if (/^\/search\?/.test(r)) r += '&_red=1&_q=' + encodeURIComponent(scritta);
      window.location.replace(r); return;
    }
    var c = canonica(scritta);
    if (c !== scritta) { vaiA(c, { _pc: '1', _q: scritta }); return; }
  }

  // ---------- 3: sinonimi, dopo aver visto i risultati ----------
  var libero = !par.get('_syn') && !par.get('_red');
  var sZero = libero ? (sinonimo(scritta) || sinonimo(q)) : null;
  var sEsatto = libero ? (sinonimoEsatto(scritta) || sinonimoEsatto(q)) : null;
  if (sEsatto && (sEsatto === norm(scritta).trim() || sEsatto === norm(q).trim())) sEsatto = null;
  if (sZero && (sZero === scritta.toLowerCase().trim() || sZero === q.toLowerCase().trim())) sZero = null;
  var nascosto = false;
  function mostra() { if (nascosto && !partito) { document.documentElement.classList.remove('sechi-ricerca-attesa'); nascosto = false; } }
  if (sZero || sEsatto) {
    try {
      var st = document.createElement('style');
      st.textContent = 'html.sechi-ricerca-attesa #MainContent{visibility:hidden}';
      (document.head || document.documentElement).appendChild(st);
      document.documentElement.classList.add('sechi-ricerca-attesa'); nascosto = true;
      setTimeout(mostra, 2500);  // paracadute: mai una pagina vuota
    } catch (e) {}
  }

  function rimettiTesto(mostrato, vero) {
    if (!mostrato || !vero || mostrato === vero) return;
    try {
      if (document.title.indexOf(mostrato) !== -1) document.title = document.title.split(mostrato).join(vero);
      document.querySelectorAll('input[name="q"]').forEach(function (i) { i.value = vero; });
      var root = document.querySelector('main') || document.body;
      var tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false), nodi = [], n;
      while ((n = tw.nextNode())) if (n.nodeValue && n.nodeValue.indexOf(mostrato) !== -1) nodi.push(n);
      nodi.forEach(function (x) { x.nodeValue = x.nodeValue.split(mostrato).join(vero); });
    } catch (e) {}
  }
  function avviso(scrittaDaCliente, usata) {
    var main = document.querySelector('main .template-search__header') || document.querySelector('main');
    if (!main) return;
    var p = document.createElement('p');
    p.className = 'sechi-ricerca-avviso';
    p.style.cssText = 'margin:1rem auto;max-width:72rem;padding:0 1.5rem;font-size:1.5rem';
    p.textContent = 'Risultati per «' + usata + '» (hai cercato «' + scrittaDaCliente + '»).';
    main.appendChild(p);
  }
  function avvia() {
    try {
      var schede = document.querySelectorAll('#product-grid > li, #product-grid .grid__item');
      var risultati = schede.length;
      if (risultati === 0 && sZero) { vaiA(sZero, { _syn: '1', _q: scritta }); return; }
      if (risultati > 0 && sEsatto) {
        var titoli = [];
        document.querySelectorAll('#product-grid [id^="CardLink-"], #product-grid .card__heading a').forEach(function (a) { var t = (a.textContent || '').trim(); if (t && titoli.indexOf(t) === -1) titoli.push(t); });
        var termini = [scritta].concat(gruppo(sEsatto));
        var pertinente = titoli.slice(0, 5).some(function (t) { return termini.some(function (g) { return copre(g, t); }); });
        if (!pertinente) { vaiA(sEsatto, { _syn: '1', _q: scritta }); return; }
      }
      mostra();
      if (par.get('_syn') || par.get('_red')) avviso(scritta, q);
      else if (par.get('_pc')) rimettiTesto(q, scritta);
    } catch (e) { mostra(); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia); else avvia();
})();
